import { render, staticRenderFns } from "./BaseBankAccount.vue?vue&type=template&id=5e12fba0&scoped=true&"
import script from "./BaseBankAccount.vue?vue&type=script&lang=js&"
export * from "./BaseBankAccount.vue?vue&type=script&lang=js&"
import style0 from "./BaseBankAccount.vue?vue&type=style&index=0&id=5e12fba0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e12fba0",
  null
  
)

export default component.exports